import React from 'react';
import { BoltFillIcon } from '@zep/icons';
import { cn } from '@zep/utils';
export function PlanIcon({
  className,
  iconClassName
}: {
  className?: string;
  iconClassName?: string;
}) {
  return <div className={cn('rounded-[4px] p-[2px]', className)} data-sentry-component="PlanIcon" data-sentry-source-file="PlanIcon.tsx">
      <BoltFillIcon className={cn('size-[11px] text-white', iconClassName)} data-sentry-element="BoltFillIcon" data-sentry-source-file="PlanIcon.tsx" />
    </div>;
}